import { ImagePage } from "components/molecules/ImagePage";
import { ImageDTO } from "types";
interface ImageLandingProps {
  image: ImageDTO;
}
export const ImageLanding = ({
  image
}: ImageLandingProps) => {
  return <ImagePage imageDto={image} data-sentry-element="ImagePage" data-sentry-component="ImageLanding" data-sentry-source-file="index.tsx" />;
};